import React from "react";
import { Info, AlertTriangle } from "lucide-react";

export default function NoteBlock({ block }) {
  const warning = block.variant === "warning";
  return (
    <div
      className={`flex items-start gap-3 rounded-xl border p-4 print-avoid-break ${
        warning ? "border-primary/40 bg-primary/10" : "border-info/30 bg-info/5"
      }`}
      style={warning ? {} : { borderColor: "rgba(59,130,246,0.3)", background: "rgba(59,130,246,0.06)" }}
    >
      {warning ? (
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
      ) : (
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-info" style={{ color: "#3B82F6" }} />
      )}
      <p className="text-sm leading-relaxed text-foreground/90">{block.text}</p>
    </div>
  );
}
